<template>
    <div class="body d-flex py-lg-3 py-md-2 mb-5">
        <div class="container-xxl">
            <div class="row clearfix">
                <div class="col-md-12">
                    <div class="wx-toolbar">
                        <div class="wx-search">
                            <div class="custom-dropdown">
                                <div class="dropdown-btn-filter" @click="toggleDropdownSearchArea">
                                    <span>{{ selectedSearchArea || 'Select Field' }}</span>
                                    <i class="icofont-rounded-down"></i>
                                </div>
                                <ul v-if="isDropdownSearchAreaOpen" class="dropdown-options-filters">
                                    <li @click="selectSearchArea('title')">Title</li>
                                    <li @click="selectSearchArea('clients')">Clients</li>
                                </ul>
                            </div>
                            <input id="main-search-input" type="search" class="form-control"
                                placeholder="Αναζήτηση..." aria-label="search" />
                        </div>
                        <label class="wx-date-field">
                            <span>Start Date</span>
                            <input type="date" id="start-date" v-model="startDate">
                        </label>
                        <label class="wx-date-field">
                            <span>End Date</span>
                            <input type="date" id="end-date" v-model="endDate">
                        </label>
                        <div class="wx-grow"></div>
                        <div class="wx-seg gridViewDiv" role="group" aria-label="Προβολή">
                            <button type="button" :class="{ on: !isGridView }" @click="isGridView = false" title="List"><i class="wx-ic wx-ic-list"></i></button>
                            <button type="button" :class="{ on: isGridView }" @click="isGridView = true" title="Grid"><i class="wx-ic wx-ic-grid"></i></button>
                        </div>
                        <button type="button" class="btn btn-primary wx-new" @click="createProject"
                            v-if="canCreateProject || superUser">
                            <i class="icofont-plus"></i><span>Νέο project</span>
                        </button>
                    </div>
                    <div class="wx-chips">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link" :class="{ active: filters.statusIds?.includes('0') }" href="#" role="tab"
                                    @click.prevent="handleStatusClick('0', $event)">All</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{ active: !filters.statusIds || filters.statusIds.length === 0 || filters.statusIds.includes('2') }" href="#" role="tab"
                                    @click.prevent="handleStatusClick('2', $event)"><span class="wx-st wx-st-progress">In progress</span></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{ active: filters.statusIds?.includes('3') }" href="#" role="tab"
                                    @click.prevent="handleStatusClick('3', $event)"><span class="wx-st wx-st-done">Done</span></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{ active: filters.statusIds?.includes('1') }" href="#" role="tab"
                                    @click.prevent="handleStatusClick('1', $event)"><span class="wx-st wx-st-hold">On hold</span></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{ active: filters.statusIds?.includes('5') }" href="#" role="tab"
                                    @click.prevent="handleStatusClick('5', $event)"><span class="wx-st wx-st-ongoing">On going</span></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{ active: filters.statusIds?.includes('4') }" href="#" role="tab"
                                    @click.prevent="handleStatusClick('4', $event)"><span class="wx-st wx-st-archived">Archived</span></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{ active: filters.statusIds?.includes('6') }" href="#" role="tab"
                                    @click.prevent="handleStatusClick('6', $event)"><span class="wx-st wx-st-potential">Potential</span></a>
                            </li>
                        </ul>
                        <span class="wx-hint">Ctrl/⌘ + κλικ για πολλαπλή επιλογή</span>
                    </div>
                    <div class="col-md-12 d-flex flexColumnMob w-100">
                        <div id="projectTableMobile" class="d-flex w-100 flex-column mobileRows gap-2"
                            v-for="(project, index) in data" :key="project.info.id"
                            :class="{ 'selected': selectedProjectIds.includes(project.info.id) }"
                            @click="handleRowClick(project.info?.id, $event)">
                            <div class="w-100 d-flex justify-content-between align-items-center">
                                <div class="d-flex flex-column gap-1 col-8">
                                    <div v-if="project.client?.avatar_file_name">
                                        <img :src="`/storage/clients_avatars/${project.client.avatar_file_name}`"
                                            style="width:10em">
                                    </div>
                                    <div v-else>
                                        <span v-if="project.client?.title">{{ project.client.title }}</span>
                                    </div>
                                    <div>
                                        <router-link :to="{ path: 'project', query: { id: project.info?.id } }">
                                            <span class="project-code fw-bold">{{ project.info?.code }}</span>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="dropdown-container w-100">
                                        <button class="dropbtn w-100" :style="getStatusStyle(project.status?.id)">
                                            {{ getCurrentStatus(project.status?.id) }}
                                            <i class="fa fa-caret-down"
                                                v-if="canEditProject(project) || canEditAllProjects || superUser"></i>
                                        </button>
                                        <div class="dropdown-content shadow"
                                            v-if="canEditProject(project) || canEditAllProjects || superUser">
                                            <button v-for="status in statuses" :key="status.id"
                                                @click="updateStatus(project.info?.id, status.id)"
                                                :style="getStatusStyle(status.id)">
                                                {{ status.description }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="w-100 d-flex justify-content-between pb-2 align-items-center">
                                <div>
                                    <div>
                                        <!-- <div v-if="project.creator?.avatar_file_name" class="small-column">
                                            C
                                            <img :src="`/storage/avatars/${project.creator.avatar_file_name}`"
                                                width="30" class="managerProfIcon"
                                                :title="project.creator.username">
                                        </div>
                                        <div v-else class="small-column">
                                            C {{ project.creator?.username }}
                                        </div> -->
                                        <div v-if="project.manager?.avatar_file_name" class="small-column">
                                            <img :src="`/storage/avatars/${project.manager.avatar_file_name}`"
                                                width="30" class="managerProfIcon" :title="project.manager.username">
                                        </div>
                                        <div v-if="!project.manager?.avatar_file_name" class="small-column">
                                            {{ project.manager?.username }}
                                        </div>
                                    </div>
                                </div>


                                <div class="d-flex gap-2 py-1 align-items-center text-secondary ps-1">
                                    <div><i class="icofont-ui-calendar me-1"></i> {{ project.info?.startDate }}</div>
                                    <div><i class="icofont-ui-calendar me-1"></i> {{ project.info?.endDate }}</div>
                                </div>
                                <div class="d-flex">
                                    <div class="button-group d-flex">
                                        <div class="icon-wrapper">
                                            <router-link
                                                :to="{ path: 'project', query: { id: project?.info?.id, activeTab: 'projectChat' } }">
                                                <button class="btn btn-dark comments p-1">

                                                    <i class="wx-ic wx-ic-chat" title="Unread comments"></i>
                                                    <span class="unread-comments" v-if="project.unread_comments > 0">{{
                                                        project.unread_comments }}</span> </button>
                                            </router-link>
                                        </div>
                                        <div class="icon-wrapper">
                                            <button class="btn btn-dark p-1"
                                                @click.prevent="editProject(project.info.id)"
                                                v-if="canEditProject(project) || canEditAllProjects || superUser">
                                                <i class="wx-ic wx-ic-edit" title="Edit"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Main Content (Table/Grid) -->
                        <div :class="{ 'col-md-12': !showFilters, 'col-md-9 leftCol': showFilters }">
                            <div v-if="!isGridView" class="card-body">
                                <table id="projectTable"
                                    class="table table-responsive table-hover align-middle mb-0 mis_table"
                                    style="width:100%">
                                    <thead>
                                        <tr>
                                            <th style="width:14%;">
                                                <div>Client<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('client_title')"></i></div>
                                            </th>
                                            <th style="width:20%;">
                                                <div>
                                                    project
                                                    <i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('projects.description')"></i>
                                                </div>
                                            </th>

                                            <th style="width:5%;">
                                                <div v-if="superUser" class="d-flex align-items-center">
                                                    <!-- Custom Dropdown for Creators -->
                                                    <div class="custom-dropdown">
                                                        <!-- Dropdown Button -->
                                                        <div class="dropdown-btn" @click="toggleDropdownCreator">
                                                            <span>{{ selectedCreator || 'Επιλογη Creator' }}</span>
                                                            <i class="icofont-rounded-down"></i>
                                                        </div>

                                                        <!-- Dropdown Options -->
                                                        <ul v-if="isDropdownCreatorOpen" class="dropdown-options">
                                                            <li
                                                                @click="selectCreator({ id: null, username: 'All Creators' })">
                                                                All Creators
                                                                <img src="../assets/images/icons8-superman.svg"
                                                                    alt="Citrine Logo" class="menu-img ms-2"
                                                                    style="width: 1.5em" />
                                                            </li>
                                                            <li v-for="creator in creators" :key="creator.id"
                                                                @click="selectCreator(creator)">
                                                                {{ creator.username }}
                                                                <img v-if="String(creator.id) !== currentUserId()"
                                                                    src="../assets/images/icons8-superman.svg"
                                                                    alt="Superman Icon" class="menu-img ms-2"
                                                                    style="width: 1.5em" />
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div v-else>
                                                    Creator
                                                    <i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('c.username')"></i>
                                                </div>
                                            </th>



                                            <th style="width:5%;">
                                                <div v-if="superUser" class="d-flex align-items-center">

                                                    <div class="custom-dropdown">
                                                        <div class="dropdown-btn" @click="toggleDropdown">
                                                            <span>{{ selectedManager || 'Επιλογη Manager' }}</span>
                                                            <i class="icofont-rounded-down"></i>
                                                        </div>
                                                        <ul v-if="isDropdownOpen" class="dropdown-options">
                                                            <li
                                                                @click="selectManager({ id: null, username: 'All Managers' })">
                                                                All Managers <img
                                                                    src="../assets/images/icons8-superman.svg"
                                                                    alt="Citrine Logo" class="menu-img ms-2"
                                                                    style="width:2em">
                                                            </li>
                                                            <li v-for="manager in managers" :key="manager.id"
                                                                @click="selectManager(manager)">
                                                                {{ manager.username }}

                                                                <!-- Show superman icon unless it's the current user -->
                                                                <img v-if="String(manager.id) !== currentUserId()"
                                                                    src="../assets/images/icons8-superman.svg"
                                                                    alt="Superman Icon" class="menu-img ms-2"
                                                                    style="width: 1.5em" />
                                                            </li>
                                                        </ul>
                                                    </div>

                                                </div>
                                                <div v-else>
                                                    Manager
                                                    <i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('m.username')"></i>
                                                </div>
                                            </th>
                                            <th style="width:10%;">
                                                <div>
                                                    Start Date
                                                    <i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('projects.startDate')"></i>
                                                </div>
                                            </th>

                                            <th style="width:10%;">
                                                <div>
                                                    End Date
                                                    <i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('projects.endDate')"></i>
                                                </div>
                                            </th>

                                            <th style="width:14%;">
                                                <div>Status<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('projects.statusId')"></i></div>
                                            </th>
                                            <th class="no-after"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(project, index) in data" :key="project.info.id"
                                            :class="{ 'selected': selectedProjectIds.includes(project.info.id) }"
                                            @click="handleRowClick(project.info?.id, $event)">
                                            <td v-if="project.client?.avatar_file_name">
                                                <img :src="`/storage/clients_avatars/${project.client.avatar_file_name}`"
                                                    style="width:10em">
                                            </td>
                                            <td v-else>
                                                <span v-if="project.client?.title">{{ project.client.title }}</span>
                                            </td>
                                            <td>
                                                <router-link :to="{ path: 'project', query: { id: project.info?.id } }">
                                                    <span class="project-code">{{ project.info?.code }}</span>
                                                </router-link>
                                            </td>


                                            <td v-if="project.creator?.avatar_file_name" class="small-column">
                                                <img :src="`/storage/avatars/${project.creator.avatar_file_name}`"
                                                    width="30" class="managerProfIcon"
                                                    :title="project.creator.username">
                                            </td>
                                            <td v-else class="small-column">
                                                {{ project.creator?.username }}
                                            </td>

                                            <td v-if="project.manager?.avatar_file_name" class="small-column">
                                                <img :src="`/storage/avatars/${project.manager.avatar_file_name}`"
                                                    width="30" class="managerProfIcon"
                                                    :title="project.manager.username">
                                            </td>
                                            <td v-if="!project.manager?.avatar_file_name" class="small-column">
                                                {{ project.manager?.username }}
                                            </td>


                                            <td>{{ project.info?.startDate }}</td>
                                            <td> {{ project.info?.endDate }}</td>

                                            <td>
                                                <div class="dropdown-container w-100">
                                                    <button class="dropbtn w-100"
                                                        :style="getStatusStyle(project.status?.id)">
                                                        {{ getCurrentStatus(project.status?.id) }}
                                                        <i class="fa fa-caret-down"
                                                            v-if="canEditProject(project) || canEditAllProjects || superUser"></i>
                                                    </button>
                                                    <div class="dropdown-content shadow"
                                                        v-if="canEditProject(project) || canEditAllProjects || superUser">
                                                        <button v-for="status in statuses" :key="status.id"
                                                            @click="updateStatus(project.info?.id, status.id)"
                                                            :style="getStatusStyle(status.id)">
                                                            {{ status.description }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="button-group">
                                                    <div class="icon-wrapper">
                                                        <router-link
                                                            :to="{ path: 'project', query: { id: project?.info?.id, activeTab: 'projectChat' } }">
                                                            <button class="btn btn-dark comments">

                                                                <i class="wx-ic wx-ic-chat" title="Unread comments"></i>
                                                                <span class="unread-comments"
                                                                    v-if="project.unread_comments > 0">{{
                                                                        project.unread_comments }}</span></button>
                                                        </router-link>
                                                    </div>
                                                    <div class="icon-wrapper">
                                                        <button class="btn btn-dark"
                                                            @click.prevent="editProject(project.info.id)"
                                                            v-if="canEditProject(project) || canEditAllProjects || superUser">
                                                            <i class="wx-ic wx-ic-edit" title="Edit"></i>
                                                        </button>
                                                    </div>

                                                </div>
                                            </td>

                                        </tr>
                                        <tr class="col" v-if="!data || !data.length">
                                            <td colspan="100">No data</td>

                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                            <div v-if="isGridView" class="row g-3">
                                <div v-for="(project, index) in data" :key="project.info.id"
                                    class="col-md-4 col-sm-6 mb-2">
                                    <div class="card h-100" style="background: #e7e7e7; color: #545454;">
                                        <div class="card-body position-relative py-4">
                                             <router-link
                                                        :to="{ path: 'project', query: { id: project.info?.id } }">
                                            <!-- Header Section -->
                                            <div class="d-flex align-items-center mb-3">
                                                <div class=""
                                                    style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                                                   

                                                        <h6 class="mb-0 mt-2 fw-bold">{{ project.info?.code }}</h6>
                                                   
                                                    <span class="d-block small-14 mb-0">{{ project.client?.title
                                                        }}</span>
                                                </div>
                                            </div>

                                            <!-- Creator and Manager -->
                                            <div class="d-flex align-items-center mb-2">
                                                <span class="me-2 fw-bold">Creator:</span>
                                                <img v-if="project.creator?.avatar_file_name"
                                                    :src="`/storage/avatars/${project.creator.avatar_file_name}`"
                                                    width="30" class="managerProfIcon">
                                                <span v-else>{{ project.creator?.username }}</span>
                                            </div>
                                            <div class="d-flex align-items-center mb-2">
                                                <span class="me-2 fw-bold">Manager:</span>
                                                <img v-if="project.manager?.avatar_file_name"
                                                    :src="`/storage/avatars/${project.manager.avatar_file_name}`"
                                                    width="30" class="managerProfIcon">
                                                <span v-else>{{ project.manager?.username }}</span>
                                            </div>

                                            <!-- Project Dates -->
                                            <div class="mb-2">
                                                <span class="fw-bold">Dates:</span> {{ project.info?.startDate }} - {{
                                                    project.info?.endDate }}
                                            </div>

                                            <!-- Action Buttons -->
                                            <div class="action-buttons">
                                                <router-link
                                                    :to="{ path: 'project', query: { id: project?.info?.id, activeTab: 'projectChat' } }">
                                                    <button class="btn btn-dark comments">
                                                        <i class="wx-ic wx-ic-chat" title="Unread comments"></i>
                                                        <span class="unread-comments"
                                                            v-if="project.unread_comments > 0">{{
                                                                project.unread_comments }}</span></button>
                                                </router-link>
                                                <button class="btn btn-dark edit"
                                                    @click.prevent="editProject(project.info.id)"
                                                    v-if="canEditProject(project) || canEditAllProjects || superUser">
                                                    <i class="wx-ic wx-ic-edit" title="Edit"></i>
                                                </button>
                                                <button class="btn btn-dark delete"
                                                    @click.prevent="archiveProject(project.info.id)"
                                                    v-if="canArchive || superUser">
                                                    <i class="wx-ic wx-ic-trash" title="Archive"></i>
                                                </button>
                                            </div>

                                            <!-- Status Dropdown -->
                                            <div class="dropdown-container2 w-100">
                                                <button class="dropbtn w-50"
                                                    :style="getStatusStyle(project.status?.id)">
                                                    {{ getCurrentStatus(project.status?.id) }}
                                                    <i class="fa fa-caret-down"
                                                        v-if="canEditProject(project) || canEditAllProjects || superUser"></i>
                                                </button>
                                                <div class="dropdown-content2"
                                                    v-if="canEditProject(project) || canEditAllProjects || superUser">
                                                    <button v-for="status in statuses" :key="status.id"
                                                        @click="updateStatus(project.info?.id, status.id)"
                                                        :style="getStatusStyle(status.id)">
                                                        {{ status.description }}
                                                    </button>
                                                </div>
                                            </div>
                                         </router-link>
                                        </div>

                                    </div>
                                </div>

                                <!-- No Data Message -->
                                <div class="col" v-if="!data || !data.length">
                                    <p>No data</p>
                                </div>
                            </div>
                            <nav aria-label="Page navigation">
                                <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                                    <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                                        :key="index" :class="{ active: paginationLink.active }">
                                        <router-link
                                            :to="{ path: 'projects', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }"
                                            v-if="paginationLink.url">
                                            <span class="page-link" v-html="paginationLink.label"></span>
                                        </router-link>
                                        <span class="page-link" v-else v-html="paginationLink.label"></span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <!-- Filters Column -->
                        <div v-if="showFilters" class="col-md-3 rightCol">
                            <div class="card border-0 mb-2">
                                <div
                                    class="card-header mb-5 py-1 px-0 d-sm-flex align-items-center justify-content-between">
                                    <div>
                                        <button type="button" class="ms-0 ms-sm-3 btn"
                                            style="color:var(--secondary-color); font-weight:bold"
                                            @click="createProject" v-if="canCreateProject || superUser">
                                            <i class="icofont-plus me-xl-2 me-0 fs-6"></i>New project
                                        </button>
                                    </div>
                                    <div class="ms-3 d-flex align-items-center">
                                        <i class="wx-ic wx-ic-list" v-if="isGridView" title="List" @click="isGridView = false"></i>
                                        <div v-if="!isGridView" class="wx-ic-on">
                                            <i class="wx-ic wx-ic-list" title="List" @click="isGridView = false"></i>
                                        </div>
                                        <i class="wx-ic wx-ic-grid" v-if="!isGridView" title="Grid" @click="isGridView = true"></i>
                                        <div v-if="isGridView" class="wx-ic-on">
                                            <i class="wx-ic wx-ic-grid" title="Grid" @click="isGridView = true"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="filter-section mt-3 w-sm-100">

                                    <div class="d-flex align-items-center mb-3">
                                        <select class="ms-3 nav-link rounded me-2 selectSearch" v-model="searchArea">
                                            <option value="title" selected>Title</option>
                                            <option value="clients">Clients</option>
                                        </select>
                                        <input id="main-search-input" type="search" class="form-control"
                                            placeholder="Αναζήτηση..." aria-label="search"
                                            aria-describedby="addon-wrapping" />
                                    </div>

                                    <div>
                                        <div class="card border-0 mb-2 no-bg">
                                            <div
                                                class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between main-button-area">
                                                <ul class="nav nav-tabs tab-body-header rounded mt-sm-0 mt-3 ms-0 ms-sm-3 prtab-set w-sm-100"
                                                    role="tablist">
                                                    <li class="nav-item col" v-for="status in statusFilters"
                                                        :key="status.id">
                                                        <a :class="statusClass(status.id)"
                                                            @click.prevent="applyStatusFilter(status.id)" href="#"
                                                            role="tab">{{
                                                                status.name }}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-sm-100">
                                        <ul class="nav nav-tabs tab-body-header rounded w-100 mb-2 " role="tablist">

                                            <li class="nav-item ">
                                                <a :class="{ 'nav-link text-center active': filters.statusIds?.includes('0'), 'nav-link text-center': !filters.statusIds?.includes('0') }"
                                                    @click.prevent="handleStatusClick('0', $event)" href="#" role="tab">
                                                    <span class="nav-item nav-link"
                                                        style="font-size: normal;">All</span>
                                                </a>
                                            </li>

                                            <li class="nav-item">
                                                <a :class="{
                                                    'nav-link text-center active': !filters.statusIds || filters.statusIds.includes('2'),
                                                    'nav-link text-center': filters.statusIds && !filters.statusIds.includes('2')
                                                }" @click.prevent="handleStatusClick('2', $event)" href="#" role="tab">
                                                    <span class="wx-st wx-st-progress" title="In Progress">In progress</span>
                                                </a>
                                            </li>

                                            <li class="nav-item ">
                                                <a :class="{ 'nav-link text-center active': filters.statusIds?.includes('3'), 'nav-link text-center': !filters.statusIds?.includes('3') }"
                                                    @click.prevent="handleStatusClick('3', $event)" href="#" role="tab">
                                                    <span class="wx-st wx-st-done" title="Done">Done</span>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a :class="{ 'nav-link text-center active': filters.statusIds?.includes('1'), 'nav-link text-center': !filters.statusIds?.includes('1') }"
                                                    @click.prevent="handleStatusClick('1', $event)" href="#" role="tab">
                                                    <span class="wx-st wx-st-hold" title="On Hold">On hold</span>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a :class="{ 'nav-link text-center active': filters.statusIds?.includes('5'), 'nav-link text-center': !filters.statusIds?.includes('5') }"
                                                    @click.prevent="handleStatusClick('5', $event)" href="#"
                                                    role="tab"><span class="wx-st wx-st-ongoing" title="On going">On going</span></a>
                                            </li>
                                            <li class="nav-item">
                                                <a :class="{ 'nav-link text-center active': filters.statusIds?.includes('4'), 'nav-link text-center': !filters.statusIds?.includes('4') }"
                                                    @click.prevent="handleStatusClick('4', $event)" href="#" role="tab">
                                                    <span class="wx-st wx-st-archived" title="Archived">Archived</span>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a :class="{ 'nav-link text-center active': filters.statusIds?.includes('6'), 'nav-link text-center': !filters.statusIds?.includes('6') }"
                                                    @click.prevent="handleStatusClick('6', $event)" href="#" role="tab">
                                                    <span class="wx-st wx-st-potential" title="Potential">Potential</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- Date Filters -->
                                    <div class="mb-3 d-flex align-items-center">
                                        <label for="start-date" class="form-label me-2">Start date:</label>
                                        <input type="date" id="start-date" v-model="startDate"
                                            class="form-control w-auto" />
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label for="end-date" class="form-label me-2">End date:</label>
                                        <input type="date" id="end-date" v-model="endDate"
                                            class="form-control w-auto" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Create Project-->
                <div class="modal fade" id="create-project-form" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header border-0">
                                <h3 class="modal-title fw-bold" id="createprojectlLabel">New Project</h3>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <!-- Left Column -->
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label for="projectTitle" class="form-label" aria-label="Title"
                                                aria-placeholder="Title">Title<sup>*</sup></label>
                                            <input type="text" class="form-control" id="projectTitle"
                                                placeholder="Title" name="title" v-model="projectData.title">
                                        </div>
                                        <div class="mb-3">
                                            <label for="projectDescriptionTinyMce"
                                                class="form-label">Description</label>
                                            <Editor api-key="no-api-key" :init="tinymceInit" v-model="projectData.body"
                                                style="min-height:500px"></Editor>
                                        </div>
                                        <div class="mb-3" v-if="userInfo && projectData.managerId == userInfo.id">
                                            <label for="projectDescriptionTinyMce" class="form-label">Manager's
                                                brief</label>
                                            <Editor api-key="no-api-key" :init="tinymceInit"
                                                v-model="projectData.manager_brief"></Editor>
                                        </div>
                                    </div>

                                    <!-- Right Column -->
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label">Client<sup>*</sup></label>
                                            <Select2 :options="allData.clients" v-model="projectData.clientId"
                                                :settings="select2Settings" />
                                        </div>
                                        <div class="mb-3" v-if="superUser || canEditProjectCreator">
                                            <label class="form-label">Creator</label>
                                            <Select2 :options="allData.users" v-model="projectData.createdBy"
                                                :settings="select2Settings" />
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label">Status<sup>*</sup></label>
                                            <Select2 :options="allData.statuses" v-model="projectData.statusId"
                                                :settings="select2Settings" />
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label">Services<sup>*</sup></label>
                                            <Select2 :options="allData.services" v-model="projectData.serviceId"
                                                :settings="select2Settings" />
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label">Manager<sup>*</sup></label>
                                            <Select2 ref="managerSelect" :options="filteredUsersForManager"
                                                v-model="projectData.managerId" :settings="select2Settings" />
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label">Assigned users</label>
                                            <Select2 ref="assignedUsersSelect" :options="filteredUsersForAssigned"
                                                v-model="projectData.assignedUsers"
                                                :settings="{ ...select2Settings, multiple: true }" />
                                        </div>
                                        <div class="mb-3">
                                            <label for="projectEstimatedHours" class="form-label"
                                                aria-label="Estimated hours"
                                                aria-placeholder="Estimated hours">Estimated hours</label>
                                            <input type="number" class="form-control" id="projectEstimatedHours"
                                                placeholder="Estimated hours" name="estimatedHours"
                                                v-model="projectData.estimatedTime">
                                        </div>
                                        <div class="mb-3">
                                            <div class="row">

                                                <div class="col">
                                                    <label for="projectStartDate" class="form-label">Start Date<sup>*</sup></label>
                                                    <input type="date" class="form-control" id="projectStartDate"
                                                        name="startDate" v-model="projectData.startDate">
                                                </div>
                                                <div class="col">
                                                    <label for="projectEndDate" class="form-label">End Date<sup>*</sup></label>
                                                    <input type="date" class="form-control" id="projectEndDate"
                                                        name="endDate" v-model="projectData.endDate">
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <!-- Full Width Payable Section -->
                                    <div class="col-md-12">
                                        <div class="mb-3 payable-container">
                                            <div class="mb-3">
                                                <label class="form-label">Payable<sup>*</sup></label>
                                                <Select2
                                                    :options="[{ id: '', text: 'Παρακαλώ επιλέξτε' }, { id: '0', text: 'No' }, { id: '1', text: 'Yes' }]"
                                                    v-model="projectData.payable" :settings="select2Settings" />
                                            </div>
                                            <div class="payable-fields" v-if="projectData.payable == '1'">
                                                <div class="mb-3">
                                                    <label class="form-label">Pay Manager</label>
                                                    <Select2 :options="allData.users" v-model="projectData.payManagerId"
                                                        :settings="select2Settings" />
                                                </div>
                                                <div class="mb-3">
                                                    <label class="form-label">Invoiced</label>
                                                    <Select2
                                                        :options="[{ id: '', text: 'Παρακαλώ επιλέξτε' }, { id: '0', text: 'No' }, { id: '1', text: 'Yes' }]"
                                                        v-model="projectData.invoiced" :settings="select2Settings" />
                                                </div>
                                                <div class="mb-3">
                                                    <label class="form-label">Paid</label>
                                                    <Select2
                                                        :options="[{ id: '', text: 'Παρακαλώ επιλέξτε' }, { id: '0', text: 'No' }, { id: '1', text: 'Yes' }]"
                                                        v-model="projectData.paid" :settings="select2Settings" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div id="create-project-errors"></div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary"
                                    @click.prevent="submitForm">Create</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Confirmation Modal for Archiving Project -->
    <div class="modal fade" id="archive-confirmation-modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm Archive</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    Are you sure you want to archive this project?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-danger" @click="confirmArchive">Yes, Archive</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Toggle Button -->
    <button class="btn btn-toggle-filter d-none" @click="toggleFilters"
        style="position: fixed; right: 1em; top: 40vh; z-index: 1000; padding:10px; background-color: var(--secondary-color)">
        <i class="wx-ic wx-ic-filter" title="Toggle Filters"></i>
    </button>
</template>

<script>
import { editorSkin } from '@/wxHelpers';
import { statusStyle } from '@/status';
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue';
import { useFetchData } from '@/composables/useFetchData';
import { fetchAll, createOrUpdate, get, massArchiveProjects, getClientsServicesStatusesUsers } from '@/services/projects';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Editor from '@tinymce/tinymce-vue';
import Select2 from 'vue3-select2-component';
import { mapGetters } from 'vuex';
import { updateProjectStatus } from '@/services/todo';
import { get as getProject } from '@/services/projects';
import { fetchManagers } from '@/services/followup';
import { fetchUserInfo } from '@/services/user';

const defaultProjectData = {
    title: '',
    description: '',
    manager_brief: '',
    clientId: '',
    assignedUsers: [],
    serviceId: '',
    managerId: '',
    statusIds: [],
    payable: '0',
    payManagerId: '',
    invoiced: '0',
    paid: '',
    estimatedTime: '',
    startDate: '',
    endDate: ''
};

export default {
    name: 'Projects',
    data() {
        return {
            projectToArchive: null, // Store the project ID to be archived
            isGridView: false, // true for grid view, false for list view
            showFilters: false, // Track if filters are shown
        };
    },
    methods: {
        toggleFilters() {
            this.showFilters = !this.showFilters; // Toggle the filter display
        },
        canEditProject(project) {
            if (!project) { return false; }
            return localStorage.getItem('current_user_id') == project.info?.createdBy && this.userPermissions?.edit === 1;
        },
        archiveProject(projectId) {
            this.projectToArchive = projectId;
            $("#archive-confirmation-modal").modal("show");
        },
        currentUserId() {
            return localStorage.getItem('current_user_id');
        },
        handleStatusClick(statusId, event) {
            const isCtrlPressed = event.ctrlKey || event.metaKey; // Support macOS Cmd key
            const currentStatusIds = this.filters.statusIds || [];

            let newStatusIds;
            if (isCtrlPressed) {
                if (currentStatusIds.includes(statusId)) {
                    newStatusIds = currentStatusIds.filter(id => id !== statusId);
                } else {
                    newStatusIds = [...currentStatusIds, statusId];
                }
            } else {
                newStatusIds = [statusId];
            }

            this.updateFilters({ ...this.filters, statusIds: newStatusIds, page: 1 });
        },
        handleRowClick(projectId, event) {
    // Prevent navigation if it's a selection click or came from a control (like button, checkbox, etc.)
    if (event.target.closest('button, a, input, [data-stop-propagation]')) return;

    this.$router.push({ path: 'project', query: { id: projectId } });
  },
        // Confirm archiving after user approval
        async confirmArchive() {
            if (this.projectToArchive) {
                const response = await massArchiveProjects({ ids: [this.projectToArchive] });
                if (response.data.success) {
                    useToast().success(response.data.message);
                    this.fetchData();
                } else {
                    useToast().error(response.data.message);
                }
                this.projectToArchive = null; // Reset after action
                $("#archive-confirmation-modal").modal('hide');
            }
        }
        // Other existing methods
    },
    components: {
        Editor,
        Select2
    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission',

        }),
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        userPermissions() {
            return this.getUserPermission('Projects');
        },
        canEditProjectCreator() {
            return this.userPermissions?.editCreator === 1;
        },
        canEditAllProjects() {
            return this.userPermissions?.editAll === 1;
        },
        canCreateProject() {
            return this.userPermissions?.create === 1;
        },
        canArchive() {
            return this.userPermissions?.archive === 1;
        },
    },
    setup() {
        const route = useRoute();
        const router = useRouter();


        const { data, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(
            fetchAll,
            {
                page: route.query.page || 1,
                active: route.query.active || 1,
                archived: route.query.archived || 0,
                statusIds: Array.isArray(route.query.statusIds)
                    ? route.query.statusIds
                    : route.query.statusIds
                        ? [route.query.statusIds]
                        : []
            },
            {
                page: 1,
                active: 1,
                archived: 0,
            }
        );

        const projectData = ref(defaultProjectData);
        const allData = ref({});
        const selectedProjectIds = ref([]);
        const isDropdownOpen = ref(false);
        const isDropdownCreatorOpen = ref(false);
        const payableFieldsShow = ref(false);
        const searchArea = ref(route.query?.searchField || 'Title');
        const startDate = ref(route.query?.startDate || '');
        const endDate = ref(route.query?.endDate || '');
        const managers = ref([]);
        const creators = ref([]);
        const userInfo = ref(null);
        const selectedManager = ref('');
        const selectedCreator = ref('');
        const managerSelect = ref(null);
        const assignedUsersSelect = ref(null);

        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
            isDropdownCreatorOpen.value = false;
        };

        const toggleDropdownCreator = () => {
            isDropdownCreatorOpen.value = !isDropdownCreatorOpen.value;
            isDropdownOpen.value = false;
        };

        // Function to handle manager selection
        const selectManager = (manager) => {
            selectedManager.value = manager.username;
            isDropdownOpen.value = false;  // Close the dropdown after selection
            updateManagerFilter(manager.id); // Call your update manager filter function
        };

        const selectCreator = (creator) => {
            selectedCreator.value = creator.username;
            isDropdownCreatorOpen.value = false;  // Close the dropdown after selection
            updateCreatorFilter(creator.id); // Call your update manager filter function
        };

        // This is the ref for search area (title, clients, etc.)
        const selectedSearchArea = ref(searchArea.value);

        // For controlling dropdown visibility
        const isDropdownSearchAreaOpen = ref(false);

        // Toggle dropdown visibility
        const toggleDropdownSearchArea = () => {
            isDropdownSearchAreaOpen.value = !isDropdownSearchAreaOpen.value;
        };

        // Select a search field option
        const selectSearchArea = (value) => {
            selectedSearchArea.value = value;
            searchArea.value = value;
            isDropdownSearchAreaOpen.value = false;

            // Update the route query to reflect the selected value
            router.push({
                path: '/projects',
                query: { ...route.query, searchField: value },
            });
        };

        // Watch for changes to startDate and endDate and update URL filters
        watch([searchArea], ([newSearchArea]) => {
            router.push({
                path: '/projects',
                query: { ...route.query, searchField: newSearchArea },
            });
        });

        // Watch for changes to startDate and endDate and update URL filters
        watch([startDate, endDate], ([newStartDate, newEndDate]) => {
            router.push({
                path: '/projects',
                query: { ...route.query, startDate: newStartDate, endDate: newEndDate },
            });
        });

        const transformDate = (dateStr) => {
            const [day, month, year] = dateStr.split('/');
            const formattedDate = `${year}-${month}-${day}`;
            return formattedDate;
        };

        const fetchManagersData = async () => {
            try {
                const response = await fetchManagers();
                if (response.data.success) {
                    managers.value = response.data.data;
                }
            } catch (error) {
                console.error('Failed to fetch managers:', error);
            }
        };

        const fetchCreatorsData = async () => {
            try {
                const response = await fetchManagers();
                if (response.data.success) {
                    creators.value = response.data.data;
                } else {
                    console.error("Failed to fetch creators:", response.data.message);
                }
            } catch (error) {
                console.error("Failed to fetch creators:", error);
            }
        };

        const statuses = ref([]);

        const getStatusIcon = (id) => {
            const status = statuses.value.find(s => s.id === id);
            return status ? status.icon : '';
        };

        const getCurrentStatus = (id) => {
            const status = statuses.value.find(s => s.id === id);
            return status ? status.description : 'Select Status';
        };

   

        const updateStatus = async (entityId, statusId) => {
            try {
                const response = await updateProjectStatus(entityId, statusId);
                if (response.data.success) {
                    useToast().success(response.data.message);
                    fetchData();
                } else {
                    useToast().error(response.data.message);
                }
            } catch (error) {
                console.error("Failed to update status:", error);
                useToast().error("Failed to update status.");
            }
        };

        const archiveProjects = async () => {
            if (!selectedProjectIds.value.length) {
                useToast().error('Δεν έχετε επιλέξει projects');
                return;
            }
            const response = await massArchiveProjects({ ids: selectedProjectIds.value });
            if (response.data.success) {
                useToast().success(response.data.message);
                fetchData();
            } else {
                useToast().error(response.data.message);
            }
        };

        const editProject = async (id) => {
            const tmpAllData = await getClientsServicesStatusesUsers();
            let newData = { users: [], statuses: [], clients: [], services: [] };
            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
            }
            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.services.length; i++) {
                newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
            }
            allData.value = newData;
            const projectInfo = await getProject({ "id": id });
            if (projectInfo.data.success) {
                projectData.value = {
                    id: projectInfo.data.data.info.id,
                    projectId: route.query.id || 0,
                    createdBy: projectInfo.data.data.creator?.id,
                    description: projectInfo.data.data.info.description,
                    body: projectInfo.data.data.info.body,
                    manager_brief: projectInfo.data.data.info.manager_brief,
                    assignedUsers: projectInfo.data.data.assigned ? projectInfo.data.data.assigned?.map((assignedUser) => assignedUser.id) : [],
                    managerId: projectInfo.data.data.manager?.id,
                    serviceId: projectInfo.data.data.service?.id,
                    clientId: projectInfo.data.data.client?.id,
                    payable: projectInfo.data.data.info.payable || '',
                    payManagerId: projectInfo.data.data.payManager?.id,
                    invoiced: projectInfo.data.data.info.invoiced || '0',
                    paid: projectInfo.data.data.info.paid || '',
                    statusId: projectInfo.data.data.status?.id,
                    estimatedTime: projectInfo.data.data.info.estimatedTime,
                    startDate: transformDate(projectInfo.data.data.info.startDate),
                    endDate: transformDate(projectInfo.data.data.info.endDate)
                };
            }
            $("#create-project-form").modal('toggle');
        };

        const createProject = async () => {
            const tmpAllData = await getClientsServicesStatusesUsers();
            let newData = { users: [], statuses: [], clients: [], services: [] };
            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
            }
            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.services.length; i++) {
                newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
            }
            allData.value = newData;
            projectData.value = {
                title: '',
                body: '',
                description: '',
                clientId: '',
                assignedUsers: [],
                serviceId: '',
                managerId: '',
                statusId: '',
                payable: '',
                payManagerId: '',
                invoiced: '0',
                paid: '',
                estimatedTime: '',
                startDate: '',
                endDate: ''
            };
            $("#create-project-form").modal('toggle');
        };

        const submitForm = async () => {
            const response = await createOrUpdate(projectData.value);
            if (response.data.success) {
                useToast().success(response.data.message);
                $("#create-project-form").modal('toggle');
                fetchData();
            } else {
                useToast().error(response.data.message);
            }
        };

        const getPageFromUrl = (url) => {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        };

        const dropdownStyle = computed(() => ({
            top: isDropdownOpen.value ? '100%' : 'initial',
            right: isDropdownOpen.value ? '0' : 'initial'
        }));



        const closeDropdown = () => {
            isDropdownOpen.value = false;
        };

        const tinymceInit = {
            height: 500,
            license_key: 'gpl',
            ...editorSkin(),
            plugins: 'link autolink',
            toolbar: 'undo redo | bold italic underline | link',
        };

        const select2Settings = {
            dropdownParent: '#create-project-form .modal-content',
            placeholder: "Please select"
        };

        // const updateManagerFilter = (event) => {
        //     const newManagerId = event.target.value;
        //     updateFilters({ ...filters.value, managerFilter: newManagerId, page: 1 });
        // };

        const updateManagerFilter = (managerId) => {
            // Now, managerId is passed directly from the selectManager method
            updateFilters({ ...filters.value, managerFilter: managerId, page: 1 });
        };

        const updateCreatorFilter = (creatorId) => {
            updateFilters({ ...filters.value, creatorFilter: creatorId, page: 1 });
        };

        // const updateCreatorFilter = (event) => {
        //     const newCreatorId = event.target.value;
        //     updateFilters({ ...filters.value, creatorFilter: newCreatorId, page: 1 });
        // };

        const getStatusStyle = (id) => statusStyle(id, '');

        const searchAction = () => {
            setTimeout(() => {
                router.push({ path: '/projects', query: { ...route.query, search: $("#main-search-input").val() } });
            }, 300);
        };

        const filteredUsersForManager = computed(() => {
            return allData.value.users?.filter(user =>
                !projectData.value.assignedUsers.includes(String(user.id))
            ) || [];
        });

        const filteredUsersForAssigned = computed(() => {
            return allData.value.users?.filter(user =>
                String(user.id) !== projectData.value.managerId
            ) || [];
        });


        watch(() => projectData.value.managerId, (newManagerId) => {
            if (projectData.value.assignedUsers.includes(newManagerId)) {
                projectData.value.assignedUsers = projectData.value.assignedUsers.filter(id => id !== newManagerId);
            }

            // Force re-render of assigned users select
            nextTick(() => {
                assignedUsersSelect.value?.$forceUpdate?.();
            });
        });

        watch(() => projectData.value.assignedUsers, (newAssigned) => {
            if (newAssigned.includes(projectData.value.managerId)) {
                projectData.value.managerId = '';
            }

            // Force re-render of manager select
            nextTick(() => {
                managerSelect.value?.$forceUpdate?.();
            });
        });

        onMounted(async () => {
            const userInfoResponse = await fetchUserInfo();
            userInfo.value = userInfoResponse.data.info;
            $("#main-search-input").val(route.query?.search || '');
            $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
            fetchManagersData();
            fetchCreatorsData();
            const tmpAllData = await getClientsServicesStatusesUsers();
            let newData = { statuses: [] };
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, description: tmpAllData.data.statuses[i].description });
            }
            statuses.value = newData.statuses;
        });

        onUnmounted(() => {
            $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
        });

        return {
            userInfo, statuses, searchArea, startDate, endDate, updateStatus, getCurrentStatus, getStatusIcon, data, allData, paginationLinks, filters, updateManagerFilter, managers, updateCreatorFilter, creators, filteredUsersForManager, filteredUsersForAssigned,
            updateFilters, fetchData, getPageFromUrl, projectData, submitForm, editProject, createProject, selectedProjectIds, archiveProjects, toggleDropdown, closeDropdown, getStatusStyle, isDropdownOpen, dropdownStyle, tinymceInit, select2Settings, sortBy, isDropdownOpen, selectedSearchArea, isDropdownSearchAreaOpen, toggleDropdownSearchArea, selectSearchArea, searchAction, toggleDropdown, selectManager, selectedManager, toggleDropdownCreator, selectCreator, isDropdownCreatorOpen, selectedCreator
        };
    },
    metaInfo: {
        title: 'Projects',
        meta: [
            { name: 'description', content: 'MIS - Projects' },
            { property: 'og:title', content: 'MIS - Projects' },
            { property: 'og:description', content: 'This is the projects page.' }
        ]
    }
};
</script>

<style scoped>
.checkbox-wrapper {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
}

.card.selected-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

tr.selected,
div.selected {
    background: #b1afaf;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
    line-height: 28px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 28px;
}

.select2-container--default .select2-selection--single {
    height: 38px;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
    background-color: #007bff;
    border-color: #007bff;
    color: #fff;
}

.select2-container .select2-selection--single {
    z-index: 9000;
    /* Adjust this value as necessary */
}

.select2-container .select2-selection--multiple {
    z-index: 9000;
    /* Adjust this value as necessary */
}

.select2-dropdown {
    z-index: 9000 !important;
    /* Ensure this is higher than other elements */
}

.modal.show .modal-dialog {
    z-index: 1050;
}

.modal-backdrop.show {
    z-index: 1040;
}

.dropdown-container {
    position: relative;
    display: inline-block;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 90px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    width: 100%;
    /* Ensure the container is wide enough */
}

.dropdown-container:hover .dropdown-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    padding: 12px 10px;
    border: 1px solid lightgray;
    /* Stretch the dropdown to full width */
}

.dropdown-content button {
    display: block;
    /* Make buttons stack vertically */
    width: 100%;
    /* Make buttons take the full width of the container */
    margin: 0;
    /* Remove margin to avoid spacing issues */
    box-sizing: border-box;
    /* Ensure padding does not affect width */
    margin-bottom: 3px;

}

#projectTable {
    width: 100%;
    /* Full width */
    table-layout: auto;
    /* Allows the table to adjust column widths automatically */
}

.table-responsive {
    overflow-x: auto;
    /* Adds horizontal scrolling */
    -webkit-overflow-scrolling: touch;
    /* Smooth scrolling for touch devices */
}

thead th,
tbody td {}

/* Ensure images fit within the smaller columns */
table .small-column img {
    max-width: 100%;
    /* Scale the image to fit the column */
    height: auto;
}

/* Optional: Add padding adjustments for narrow columns */
table .small-column {
    padding: 4px;
    /* Adjust padding as needed */
}


.date-input-left {
    position: absolute;
    opacity: 0;
    width: 30px;
    transform: scale(2.5);
    margin-left: 61px;
    cursor: pointer;
}

.date-input-right {
    position: absolute;
    opacity: 0;
    width: 30px;
    transform: scale(2.5);
    margin-left: 68px;
    cursor: pointer;
}

.calendar-icon {
    font-size: 1.5em;
    cursor: pointer;
}


.col-md-12 {
    width: 100%;
}

.button-group>button {
    width: 3em;
}

.tox-tinymce {
    height: 500px;
}

.dropdown-container button:hover {
    transition: 1s;
    transform: scale(1.1);
}

.managerProfIcon {
    border-radius: 50%;
    width: 36px;
    height: 36px !important;
    object-fit: cover;
}

.nav-tabs.tab-body-header {
    border: 0px;
}

.nav-tabs.tab-body-header .nav-link.active span {
    color: white;
}

.dropdown-btn-filter {
    cursor: pointer;
    text-transform: capitalize;
    font-weight: 600;
    color: #545454;
}

.dropdown-btn {
    cursor: pointer;
}

/* Dropdown Options List */
.dropdown-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options-filters {
    position: absolute;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: fit-content;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options li,
.dropdown-options-filters li {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #545454;
    font-weight: 600;
    border-bottom: 1px dashed lightgray;
}

.dropdown-options li:hover,
.dropdown-options-filters li:hover {
    background-color: #545454;
    color: white;
}

#projectTableMobile {
    display: none !important;
}

.icofont-calendar {
    cursor: pointer;
}

@media (max-width: 1180px) {

    #projectTable th,
    #projectTable td {
        font-size: 0.9em;
        /* Adjusts font size for smaller screens */
        padding: 0.5em;
        /* Reduces padding */
    }

    .dropdown-container,
    .button-group {
        display: block;
        /* Stacks items vertically on smaller screens */
    }

    .topbar {
        flex-direction: column-reverse;
    }

    .gridViewDiv {
        display: none;
    }

    .w-sm-100 {
        width: 100%;
    }

    .flexColumnMob {
        flex-direction: column;
    }

    .justifyBetweenMob {
        justify-content: space-between;
    }

    .menu-img {
        width: 26px !important;
    }

    #projectTable {
        display: none;
    }

    #projectTableMobile {
        display: flex !important;
    }

    .mobileRows {
        padding: 5px 10px;
        border-bottom: 1px dashed #dedede;
        margin-bottom: 12px;
    }

    .date-input-left {
        margin-left: 41px;
    }

    .date-input-right {
        margin-left: 37px;
    }

    body.modal-open {
        overflow: hidden !important;
        position: fixed;
        touch-action: none;

    }

    /* CRITICAL: TinyMCE dialogs must appear ABOVE Bootstrap modals */
    .tox-tinymce-aux,
    .tox-dialog-wrap,
    .tox-dialog,
    .tox-dialog__backdrop {
        z-index: 99999 !important;
    }
    /* Ensure Bootstrap modals stay below TinyMCE dialogs */
    .modal {
        z-index: 1050 !important;
    }

    .modal-backdrop {
        z-index: 1040 !important;
    }
}
</style>
